import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { BoardIconButton } from "../../atoms/BoardDesignSystem";
import BoardDropdownPortal from "../BoardDropdownPortal/BoardDropdownPortal";
import "./BoardTile.scss";

const BoardTile = ({
  board,
  canUpdate = false,
  canDelete = false,
  onEdit,
  onDelete,
}) => {
  const boardId = board.boardId || board.board_id || board.id;
  const { name, projectName, backgroundColor, cardCount, memberIds = [] } = board;
  const [menuOpen, setMenuOpen] = useState(false);
  const menuWrapRef = useRef(null);
  const menuPanelRef = useRef(null);
  const showActions = canUpdate || canDelete;

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onDocClick = (e) => {
      if (
        menuWrapRef.current?.contains(e.target)
        || menuPanelRef.current?.contains(e.target)
      ) {
        return;
      }
      setMenuOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [menuOpen]);

  if (!boardId) {
    return (
      <div className="pb-board-tile pb-board-tile--disabled" aria-disabled="true">
        <div
          className="pb-board-tile__preview"
          style={{ backgroundColor: backgroundColor || "#0079BF" }}
        />
        <h3 className="pb-board-tile__title">{name}</h3>
        <p className="pb-board-tile__meta">Board link unavailable</p>
      </div>
    );
  }

  return (
    <div className="pb-board-tile-wrap">
      <Link to={`/project-management/${boardId}`} className="pb-board-tile">
        <div
          className="pb-board-tile__preview"
          style={{ backgroundColor: backgroundColor || "#0079BF" }}
        />
        <h3 className="pb-board-tile__title">{name}</h3>
        <p className="pb-board-tile__meta">
          {projectName} · {cardCount} cards · {memberIds.length} members
        </p>
      </Link>

      {showActions && (
        <div
          className={`pb-board-tile__menu ${menuOpen ? "pb-board-tile__menu--open" : ""}`}
          ref={menuWrapRef}
        >
          <BoardIconButton
            icon="⋯"
            label="Board actions"
            variant="ghost"
            className="pb-board-tile__menu-btn"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setMenuOpen((open) => !open);
            }}
          />
          {menuOpen && (
            <BoardDropdownPortal
              open={menuOpen}
              anchorRef={menuWrapRef}
              menuRef={menuPanelRef}
              placement="bottom-end"
              popoverWidth={180}
              className="pb-board-tile__menu-panel"
            >
              {canUpdate && (
                <button
                  type="button"
                  className="pb-board-tile__menu-item"
                  onClick={() => {
                    setMenuOpen(false);
                    onEdit?.(board);
                  }}
                >
                  Edit board
                </button>
              )}
              {canDelete && (
                <button
                  type="button"
                  className="pb-board-tile__menu-item pb-board-tile__menu-item--danger"
                  onClick={() => {
                    setMenuOpen(false);
                    onDelete?.(board);
                  }}
                >
                  Delete board
                </button>
              )}
            </BoardDropdownPortal>
          )}
        </div>
      )}
    </div>
  );
};

export default BoardTile;
